module.exports = __webpack_public_path__ + "static/media/circle.948071b8.svg";